export enum DetailDrawerType {
  NO_OF_PROJECTS = 'no_of_projects',
  LATE_DELIVERABLES = 'late_deliverables',
  COMMENT_DENSITY = 'comment_density',
  OPEN_COMMENTS = 'open_comments',
  AVG_REVIEW_TIME = 'avg_review_time',
  OVER_DUE_DELIVERABLES = 'overdue_deliverables',
  RESOLVED_COMMENT = 'resolved_comment',
  TOTAL_OUTPUTS_APPROVED = 'total_outputs_approved',
}

export enum ViewLevel {
  ORG = 'org',
  PROJECTS = 'project',
  DELIVERABLE_SETS = 'deliverable_set',
}

export enum PeriodMetricKey {
  REVIEW_TIME_TREND = 'review_time_trend',
  RESOLUTION_RATE_TREND = 'resolution_rate_trend',
  AVG_DAYS_PER_FILE_TREND = 'avg_days_per_file_trend',
}

export enum ChartDataKey {
  REVIEW_TIME_TREND = 'avg_cycle_time_days',
  RESOLUTION_RATE_TREND = 'avg_resolution_rate_percentage',
  AVG_DAYS_PER_FILE_TREND = 'avg_days',
}

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
}

export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.4, 0, 0.2, 1] as const,
    },
  },
}

export const MONTH_FORMAT = 'MMM YYYY'
export const BUCKET_DATE_FORMAT = 'MM/DD/YYYY'
